
import React, { useEffect } from 'react'
import { InputContainer } from '../../../../../../../common/components/form/form.module';
import GoogleMapSearch from '../../../../../../../common/components/google-map-search';

export default function CargoBasicInfoComponent({ filterCustomer, handleCustomerSearch, customerListData, dropLocations, pickupLocations, setDropLocations, setPickupLocations, userInfo, handleChange, cargoValues }: any) {

    //Disabling of past time selection
    useEffect(() => {
        const input = document.getElementById("datetime") as HTMLInputElement;
        input.addEventListener("change", function () {
            const minDateTime = new Date(input.min);
            const selectedDateTime = new Date(input.value);
            if (selectedDateTime < minDateTime) {
                alert("Please select a valid time.");
                input.value = input.min; // reset to min
            }
        });

    }, []);

    return (

        <div className="w-full font-bold space-y-4">

            <div className="flex flex-row gap-4">

                <div className="flex-1">
                    <InputContainer
                        label="Existing Customer"
                        name="IsExistingUser"
                        onValueChange={(event: any) => {
                            handleChange(event, 'IsExistingUser');
                        }}
                        type="checkbox"
                        value={cargoValues?.IsExistingUser}
                    />
                </div>


                {cargoValues?.IsExistingUser && (
                    <div className="flex-1">
                        <InputContainer
                            className="w-full capitalize font-normal pl-4 pr-7 py-2 border rounded-md bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                            label="Customer Name"
                            labelField="AccountName"
                            placeholder="Type to find a customer..."
                            isLoading={customerListData?.isLoading}
                            list={customerListData?.result?.items}
                            onTypeahead={(event: any) => handleCustomerSearch({ event })}
                            onValueChange={(event: any) => {
                                handleChange(event, 'CustomerId');
                            }}
                            type="typeahead"
                            value={cargoValues?.CustomerId}
                            valueField="Id"
                        />
                    </div>
                )}
            </div>
            <div className="flex flex-row gap-4">
                {!cargoValues?.IsExistingUser &&
                    <div className="flex-1">
                        <label className="font-semibold line-clamp-2 mb-2 text-slate-800" htmlFor="grid-password">
                            Email <span className="text-red-500">*</span>
                        </label>
                        <input
                            required
                            type="email"
                            name={"Email"}

                            className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                            onChange={(event) => {
                                handleChange(
                                    event.target.value,
                                    'Email'
                                );

                            }}
                            value={cargoValues?.Email} />
                    </div>}
                {!cargoValues?.IsExistingUser &&
                    <div className="flex-1">
                        <label className="font-semibold line-clamp-2 mb-2 text-slate-800" htmlFor="grid-password">
                            Name  <span className="text-red-500">*</span>
                        </label>
                        <input
                            required
                            type="text"
                            name={"Name"}
                            className="w-full border font-normal  rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                            onChange={(event) => {
                                handleChange(
                                    event.target.value,
                                    'Name'
                                );
                            }}
                            value={cargoValues?.Name} />
                    </div>}
                {!cargoValues?.IsExistingUser &&
                    <div className="flex-1">
                        <label className="font-semibold line-clamp-2 mb-2 text-slate-800" htmlFor="grid-password">
                            PhoneNumber <span className="text-red-500">*</span>
                        </label>
                        <input
                            required
                            type="text"
                            maxLength={10}
                            name={"PhoneNumber"}
                            className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                            onChange={(event) => {
                                handleChange(
                                    event.target.value.replace(/\D/g, ''),
                                    'PhoneNumber'
                                );
                            }}
                            value={cargoValues?.PhoneNumber} />
                    </div>}
            </div>
            {cargoValues?.CustomerId && cargoValues?.IsExistingUser &&
                <div className="flex flex-row gap-4">
                    <div className="flex-1">
                        <label className="font-semibold line-clamp-2 mb-2  text-slate-800" htmlFor="grid-password">
                            Email
                        </label>
                        <div className="border font-normal  rounded-md px-4 py-2 text-gray-500 bg-gray-50 cursor-not-allowed">
                            {filterCustomer?.Email}
                        </div>

                    </div>

                    <div className="flex-1">
                        <label className="font-semibold line-clamp-2 mb-2 text-slate-800">Phone Number</label>
                        <div className="border font-normal rounded-md px-4 py-2 text-gray-500 bg-gray-50 cursor-not-allowed">
                            {filterCustomer?.PhoneNumber}
                        </div>
                    </div>
                </div>}
            <div className="flex flex-col gap-4">
                <div >
                    <label className="font-semibold line-clamp-2 mb-2 text-slate-800">
                        From <span className="text-red-500">*</span>
                    </label>

                    <GoogleMapSearch
                        className="w-full font-normal  ps-8  pe-10 py-2 border rounded-md bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                        setLocation={setPickupLocations}
                        location={pickupLocations}
                        placeholder="From Address"
                        required
                    />

                </div>

                <div >
                    <label className="font-semibold line-clamp-2 mb-2 text-slate-800">
                        To <span className="text-red-500">*</span>
                    </label>

                    <GoogleMapSearch
                        className="w-full font-normal  ps-8  pe-10 py-2 border rounded-md bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                        setLocation={setDropLocations}
                        location={dropLocations}
                        placeholder="To Address"
                        required
                    />

                </div>
            </div>



            <div className="flex flex-col sm:flex-row gap-4">
                <div className="flex-1">
                    <label className=" font-semibold line-clamp-2 mb-2 text-slate-800">
                        Name <span className="text-red-500">*</span>
                    </label>

                    <input
                        required
                        type="text"
                        name="name"
                        className=" w-full font-normal border rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                        onChange={(event) => handleChange(event.target.value, 'name')}
                        value={cargoValues?.name}
                    />

                </div>
                <div className="flex-1">
                    <label className="font-semibold line-clamp-2 mb-2 text-slate-800">
                        Phone Number <span className="text-red-500">*</span>
                    </label>

                    <input
                        required
                        pattern="\d{10}"
                        maxLength={10}
                        type="text"
                        name="phoneNumber"
                        className=" w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                        onChange={(event) => handleChange(event.target.value.replace(/\D/g, ''), 'toPhoneNumber')}
                        value={cargoValues?.toPhoneNumber}
                    />

                </div>
                <div className="flex-1">
                    <label className="font-semibold line-clamp-2 mb-2 text-slate-800">
                        Schedule Date & Time<span className="text-red-500">*</span>
                    </label>

                    <input
                        required
                        id="datetime"
                        type="datetime-local"
                        name="scheduleDate"
                        min={
                            new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
                                .toISOString()
                                .slice(0, 16)
                        }
                        className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                        onClick={(event) => {
                            const input = event.target as HTMLInputElement; // Type cast to HTMLInputElement
                            input.showPicker(); // Now you can call showPicker() safely
                        }}
                        onChange={(event) => handleChange(event.target.value, 'date')}
                        value={cargoValues?.date}
                    />

                </div>
            </div>


            <div>
                <label className="font-semibold line-clamp-2 mb-2 text-slate-800">Additional Information</label>

                <textarea

                    name="additionalInfo"
                    className="w-full h-20 font-normal border rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                    onChange={(event) => handleChange(event.target.value, 'Description')}
                    value={cargoValues?.Description}
                />

            </div>

        </div>



    )
}